<template>
  <div class="check-source-stage-changes">
    <app-panel title="Изменения в базе">
      <div v-if="isMounted">
        <div class="check-source-stage-changes__row">
          <div class="check-source-stage-changes__col">
            <app-v-select :options="[]" v-model="changesBody.users_separators"
                          :multiple="true"
                          taggable push-tags no-drop :close-on-select="false" searchable
                          :reduce-function="opt => opt"
                          label="Разделители имен пользователей"
                          placeholder=";;"
                          :useDynamicKey="false"
            >
              <div slot="help">
                Нажмите <span style="font-weight: 500">Enter</span> после ввода разделителя
              </div>
            </app-v-select>
          </div>
        </div>

        <div class="check-source-stage-changes__row">
          <div class="check-source-stage-changes__col">
            <vs-checkbox class="house-importer-app-checkbox" v-model="changesBody.users_ownership_part">В именах
              пользователей есть указание доли собственности
            </vs-checkbox>
          </div>
        </div>

        <div class="check-source-stage-changes__row">
          <div class="check-source-stage-changes__col">
            <app-v-select :options="[]" v-model="changesBody.inactive_dev_types"
                          :multiple="true"
                          taggable push-tags no-drop :close-on-select="false" searchable
                          :reduce-function="opt => opt"
                          label="Типы приборов которые надо отключить"
                          placeholder="хвс2"
                          :useDynamicKey="false"
            />
          </div>
        </div>

        <div class="check-source-stage-changes__row">
          <div class="check-source-stage-changes__col">
            <change-name-block oldLabel="Старый тип" newLabel="Новый тип" v-model="changesBody.dev_type_match"
                               label="Замена необрабатываемых типов приборов в обрабатываемые"/>
          </div>
          <div class="check-source-stage-changes__col">
            <change-name-block oldLabel="Старый номер" newLabel="Новый номер" v-model="changesBody.flats_match"
                               label="Замена номеров квартир с пробелами на указанные"/>
          </div>
        </div>
        <div class="check-source-stage-changes__info-row">
          <p>Для добавление новой строки <span style="font-weight: 500">Enter</span> - на новом значении</p>
          <p>Для удалении строки <span style="font-weight: 500">Backspace</span> - на старом пустом значении</p>
        </div>
      </div>
    </app-panel>

    <div class="check-source-stage-changes__send-button">
      <app-button color="success" @click="sendBody">Отправить</app-button>
    </div>
  </div>
</template>

<script>
  import ChangeNameBlock from "./components/ChangeNameBlock";

  export default {
    name: "CheckSourceStageChanges",
    components: {
      ChangeNameBlock
    },
    props: {
      importInfo: {}
    },
    data() {
      return {
        changesBody: {
          users_separators: [],
          users_ownership_part: false,
          dev_type_match: [],
          inactive_dev_types: [],
          flats_match: []
        },
        isMounted: false,
      }
    },
    methods: {
      resetChangesBody() {
        this.changesBody = {
          users_separators: [],
          users_ownership_part: false,
          dev_type_match: [],
          inactive_dev_types: [],
          flats_match: []
        }
      },
      async sendBody() {
        let body = Object.assign({}, this.changesBody, {import_id: this.importInfo.id});
        body.users_separators = JSON.stringify(body.users_separators);
        body.inactive_dev_types = JSON.stringify(body.inactive_dev_types);
        body.dev_type_match = JSON.stringify(body.dev_type_match.filter(v => v !== '||=||'));
        body.flats_match = JSON.stringify(body.flats_match.filter(v => v !== '||=||'));

        try {
          this.$emit('set-loading', true);
          let {data} = await this.$http.post('import/houses/stage_2', body);
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally {
          this.$emit('set-loading', false);
        }

      }
    },
    beforeMount() {
      this.resetChangesBody();
    },
    mounted() {
      if (this.importInfo.files_parameters && this.importInfo.files_parameters.mid_update_params) {
        this.$nextTick(() => {
          this.$set(this.changesBody, 'users_separators', this.importInfo.files_parameters.mid_update_params.user_separators);
          this.$set(this.changesBody, 'users_ownership_part', this.importInfo.files_parameters.mid_update_params.users_ownership_part);
          this.$set(this.changesBody, 'dev_type_match', this.importInfo.files_parameters.mid_update_params.dev_type_pairs);
          this.$set(this.changesBody, 'inactive_dev_types', this.importInfo.files_parameters.mid_update_params.dev_types_to_deactivate);
          this.$set(this.changesBody, 'flats_match', this.importInfo.files_parameters.mid_update_params.flats_matchings);
        });
      }

      this.$nextTick(() => {
        this.isMounted = true;
      });
    }
  }
</script>

<style lang="scss">
  .check-source-stage-changes {

    &__info-row{
      text-align: center;
      line-height: 1.1;
      font-size: 12px;
    }

    &__row {
      margin: 0 -7.5px 30px;
      display: flex;
    }

    &__col {
      padding: 0 7.5px;
      flex: 1;
    }

    &__send-button {
      position: fixed;
      right: 15px;
      bottom: 15px;
    }

  }

  .house-importer-app-checkbox {
    margin: 0;

    .con-slot-label {
      line-height: 1.1;
      color: #627084;
      font-size: 14px;
    }
  }
</style>